<template>
    <div class="row" >
        <div class="fake-link" v-for="item in data" :key="item" @click="getAttachment(action, item)">{{item.libelle}}</div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Attachment } from '@/models/Attachment';
import { store } from '@/plugins/store';

export default defineComponent({
    name: 'AttachmentList',
    props: {
        data: { type: Array as PropType<Attachment[]>, required: true },
        action: { type: String },
    },
    methods: {
        getAttachment(action: string, item: any){
            store.dispatch(action, item.id);
        }
    }
});
</script>

<style scoped>
.row {
    display: flex;
    flex-direction: column;
}
.fake-link {
    text-decoration: underline;
    color: -webkit-link;
    cursor: pointer;
}
</style>
